import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import { antGrey, appHomeCardsWidgetTitleStyle } from '@/components/styles/globalStyles';
import UserAvatar from '@/components/UserAvatar';
import { displayUserNameShort } from '@/helpers/displayHelpers';
import { RootState } from '@/reducers/reducers';
import { selectAppUser } from '@/selectors/selectors';
import { useSelector } from 'react-redux';
import Space from 'antd/lib/space';

export interface ReleasePilotWidgetProps {
    appId: string;
    releasePilotId: string | null;
    onReleaseOverview: boolean;
}

export const ReleasePilotWidget: React.FC<ReleasePilotWidgetProps> = ({ appId, releasePilotId, onReleaseOverview }) => {
    const releasePilot = useSelector((state: RootState) => {
        return selectAppUser(state, appId, releasePilotId);
    });

    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
            }}
        >
            {onReleaseOverview ?
                <Text
                    style={{
                        fontSize: '14px',
                        color: `${antGrey.grey6}`,
                    }}
                >
                    Release pilot
                </Text>
            :   <Text style={{ ...appHomeCardsWidgetTitleStyle }}>Release pilot</Text>}
            <Space align="center">
                <span style={{ ...(onReleaseOverview ? { position: 'relative', top: '-2px' } : {}) }}>
                    <UserAvatar imageUrl={releasePilot?.commsAvatars?.image48} size={24} />
                </span>
                <Text
                    style={{
                        fontSize: onReleaseOverview ? 18 : 14,
                        color: antGrey.grey9,
                        ...(onReleaseOverview ? { position: 'relative', top: '-2px' } : {}),
                    }}
                >
                    {releasePilot ? displayUserNameShort(releasePilot) : 'No release pilot selected'}
                </Text>
            </Space>
        </div>
    );
};
